module.exports = __webpack_public_path__ + "img/img_person3_232px@3x.983f0b60.png";